<template>
<main class="form w-100 m-auto overflow-hidden mel-glass-panel">
  <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors, isSubmitting }" class="m-2">
    <div class="h3 mb-3 fw-normal">
      <img alt="Icon" src="/icon.svg" class="icon" />
      {{ $t('page.forgot-password.heading') }}
    </div>
    <p>{{ $t('page.forgot-password.description') }}</p>

    <div class="form-floating">
      <Field id="email" name="email" type="email" autocomplete="email" class="form-control" placeholder="name@example.com" :class="{ 'is-invalid': errors.email }" maxlength="256" />
      <label for="email">{{ $t('field.generic.email') }}</label>
    </div>

    <div class="btn-group w-100">
      <button class="btn btn-primary py-2 w-100" type="submit" :disabled="isSubmitting">
        <span v-show="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
        {{ $t('action.send') }}
      </button>
      <RouterLink to="/" class="btn btn-outline-secondary py-2" :disabled="isSubmitting">
        {{ $t('action.cancel') }}
      </RouterLink>
    </div>
    <div v-if="errors.apiError" class="alert alert-danger mt-3 mb-0">{{ errors.apiError }}</div>
  </Form>
</main>
</template>
  
<script setup lang="ts">
import { Form, Field, GenericObject } from 'vee-validate';
import * as Yup from 'yup';
import { useAuthStore } from '@/stores';
import { toast } from 'vue3-toastify';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();

const schema = Yup.object().shape({
  email: Yup.string().email(i18n.t('validation.emailRequired')).required(i18n.t('validation.emailRequired')).email(i18n.t('validation.emailType')),
});

async function onSubmit(values: GenericObject, { setErrors }: GenericObject) {
  const authStore = useAuthStore();
  const { email } = values;

  try {
    await authStore.sendPasswordResetEmail(email);
    toast.success(i18n.t('statement.emailSent'), { autoClose: 3000 });
  } catch (error) {
    return setErrors({ apiError: error });
  }
}
</script>

<style scoped>
.form {
  max-width: 640px;
  padding: 1rem;
  transition: all 0.4s ease 0s;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (min-width: 768px) {
  .form {
    left: calc(50% + 280px);
    transform: translate(calc(-50% - 140px), -50%);
  }
}

.form .form-floating:focus-within {
  z-index: 2;
}

.form input[name="email"] {
  margin-bottom: 10px;
}
</style>
